export default "__VITE_ASSET__5cf0cf70__"